'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$26() {
  this.bgm = null;
  this.bgk = null;
  this.bgl = false;
  this.bgi = null;
  this.bgj = false;
  this.bgn = false;
  this.bgo = false;
  this.bgm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$26 as $c_Lpresto_PrestoRouter$$anon$26 };
$p = $c_Lpresto_PrestoRouter$$anon$26.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$26;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$26() {
}
export { $h_Lpresto_PrestoRouter$$anon$26 as $h_Lpresto_PrestoRouter$$anon$26 };
$h_Lpresto_PrestoRouter$$anon$26.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bgm;
});
$p.t = (function() {
  if ((!this.bgl)) {
    this.bgk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgl = true;
  }
  return this.bgk;
});
$p.ae = (function() {
  if ((!this.bgj)) {
    this.bgi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgj = true;
  }
  return this.bgi;
});
$p.w = (function() {
  if ((!this.bgo)) {
    this.bgn = false;
    this.bgo = true;
  }
  return this.bgn;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$26 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$26, "presto.PrestoRouter$$anon$26", ({
  NR: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$26 as $d_Lpresto_PrestoRouter$$anon$26 };
//# sourceMappingURL=presto.-Presto-Router$$anon$26.js.map
